import background from "../../../images/destination/background-destination-desktop.jpg";
import NavBar from "../../navbar/MainNavBar";
import { Link, useParams } from "react-router-dom";
import { data } from "../data";

const DeskDM = () => {
  const planet = useParams().planet;
  const render = data.find((n) => n.planet === planet);
  const myStyle = {
    backgroundImage: `url(${background})`,
    backgroundSize: "cover",
    minHeight: "100vh",
  };

  return (
    <div style={myStyle}>
      <NavBar />
      <p className="p-style" style={{ marginLeft: "2rem" }}>
        {" "}
        <strong className="strong">01</strong>PICK YOUR DESTINATION
      </p>
      <div
        style={{
          padding: "0 2rem",
          textAlign: "left",
          alignItems: "center",
          display: "flex",
          flexDirection: "row",
          paddingBottom: "3rem",
          justifyContent: "space-around",
          margin: "2rem auto 0",
          width: "80%",
        }}
      >
        <img
          src={render.img}
          style={{ width: "25rem", height: "25rem", margin: "5rem" }}
        />
        <div style={{ position: "relative" }}>
          <div style={{ marginBottom: "2rem" }}>
            <Link
              className="destinaion-links p-style"
              to="/destination/"
              style={{ marginLeft: 0 }}
            >
              MOON
            </Link>
            <Link
              className="destinaion-links p-style"
              style={
                render.planet === "mars"
                  ? { borderBottom: "2px solid white" }
                  : {}
              }
              to="/destination/mars"
            >
              MARS
            </Link>
            <Link
              className="destinaion-links p-style"
              style={
                render.planet === "europa"
                  ? { borderBottom: "2px solid white" }
                  : {}
              }
              to="/destination/europa"
            >
              EUROPA
            </Link>
            <Link
              className="destinaion-links p-style"
              style={
                render.planet === "titan"
                  ? { borderBottom: "2px solid white" }
                  : {}
              }
              to="/destination/titan"
            >
              TITAN
            </Link>
          </div>
          <h1 style={{ margin: 0, textTransform: "uppercase" }}>MOON</h1>
          <p>{render.text}</p>
          <span style={{ width: "80%", position: "absolute" }}></span>
          <div className="dis-box" style={{ margin: "4rem 0" }}>
            <div style={{ margin: " 0 4rem 0 0 " }}>
              {" "}
              <p className="p-style">AVG. DISTANCE</p>
              <h3 style={{ textTransform: "uppercase" }}>{render.avg}</h3>
            </div>
            <div>
              <p className="p-style" style={{ textTransform: "uppercase" }}>
                EST. TRAVEL TIME
              </p>
              <h3 style={{ textTransform: "uppercase" }}>{render.time}</h3>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DeskDM;
